import * as React from 'react';

import { ObservableHint } from '@legendapp/state';
import { use$ } from '@legendapp/state/react';

import DegreeImageContainer from '../degree-image/degree-image-container';

import ViewWrapper from '../product-view/view-wrapper';

import translate from '../../utils/translate';

import { containerStore, disclaimerStore, fullscreenStore, interiorStore, rootStore } from '../../store';
import { deviceSettingStore } from '../../store';
import BottomControlPanel from '../bottom-control-panel/bottom-control-panel';
import TopHeader from '../header/top-header';
import { HotAreas } from '../hot-areas/hot-areas';
import InteriorRender from '../interior-view/interior-render';
import { InteriorToggleButton } from '../interior-view/interior-toggle-button';
import { A11yControls } from '../media-controls/a11y-controls';
import { RotationOnboarding } from '../onboarding/rotation-onboarding/rotation-onboarding';
import MediaArea from '../product-view/media-area';

const VISUALIZER_CONTAINER_ID = 'Visualizer_Feature_app';

// @TODO rename!!!
export default function App() {
	const isLoaded = use$(rootStore.isLoaded, { suspense: true });
	const isTouchDevice = use$(deviceSettingStore.isTouchDevice);
	const isInteriorLoaded = use$(interiorStore.isInteriorLoaded);
	const isTopHeaderVisible = use$(fullscreenStore.isTopHeaderVisible);
	const disclaimerId = use$(disclaimerStore.disclaimerId);

	const mediaContent = (
		<>
			<div id={disclaimerId} />
			<DegreeImageContainer />
			{isInteriorLoaded && <InteriorRender />}
			{isTouchDevice && <HotAreas />}
			{isTopHeaderVisible && <TopHeader />}
			<RotationOnboarding />
			<InteriorToggleButton />
			<A11yControls />
		</>
	);

	return (
		isLoaded.bff && (
			<ViewWrapper
				id={VISUALIZER_CONTAINER_ID}
				role="region"
				aria-label={translate('global.ariaLabel.vehicleTurntableDescription')}
				ref={element => {
					if (element) {
						containerStore.container.set(ObservableHint.opaque(element));
					}
				}}
			>
				<MediaArea>{mediaContent}</MediaArea>
				<BottomControlPanel />
			</ViewWrapper>
		)
	);
}
